import { type FOfferType, isResidential } from '@/packages/JsonQuery';

import { type IParking } from '../types';

import { EXTENDED_PARING_TYPES, PARKING_TYPES_LIST } from './constants';

export function getParkingTypes(offerType: FOfferType): IParking[] {
  if (isResidential(offerType)) {
    return PARKING_TYPES_LIST;
  } else {
    return EXTENDED_PARING_TYPES;
  }
}
